import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public resetForm: FormGroup;
  public submitted: boolean = false;
  public userToken: any;
  public userRole: any;
  public userEmail: any;
  public flag: any;

  get f() {
    return this.resetForm.controls;
  }

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      password: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,128}$')]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: this.passwordMatchValidator('password', 'confirmPassword')
    })
    this._activatedRoute.queryParams.subscribe((val) => {
      this.userToken = val.token;
      this.userRole = val.roleId;
      this.userEmail = val.email;
      this.flag = val.flag;
    });
  }

  /**
   * Custom validator function to check if two form control values match.
   * Returns a validator function that compares the values of two form controls.
   * If the values don't match, sets an error on the matching control.
   * If the values match, clears any existing errors on the matching control.
   * @param controlName The name of the control to validate.
   * @param matchingControlName The name of the control to match against.
   * @returns Validator function for the password match validation.
   */
  passwordMatchValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  /**
   * Sets the user's password.
   * Submits the reset form and sends a POST request to the appropriate API endpoint based on the flag.
   * If the flag is 'passwordReset', sends a request to reset the user's password.
   * If the flag is not 'passwordReset', sends a request to verify the user's email address.
   * Redirects the user to the home page after successful password setting.
   * Displays success or error message based on the API response.
   */
  setPassword() {
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    }
    let confirmPassword = this.resetForm.value.confirmPassword;
    let apiUrl;
    let dataObject;
    if (this.flag == 'passwordReset') {
      apiUrl = '/user/reset-password';
      dataObject = {
        token: this.userToken,
        email: this.userEmail,
        newPassword: confirmPassword,
        roleId: this.userRole
      }
    }
    else {
      apiUrl = '/user/verify-email';
      dataObject = {
        token: this.userToken,
        email: this.userEmail,
        newPassword: confirmPassword,
        roleId: this.userRole
      }
    }
    this.apiService.postAPIV3(apiUrl, dataObject).subscribe(res => {
      if (res['statusCode'] == 200) {
        this.router.navigate(['/']);
        this.toastService.showSuccess(res['message'], 'Success')
      }
      else {
        this.toastService.showError(res['message'], 'Error')
      }
    })
  }
}
